import { SearchBar } from "./search/modules/searchbar";

const searchbars: NodeListOf<HTMLElement> = document.querySelectorAll(".m-SearchDropdown");

if (searchbars)
{

    searchbars.forEach((searchbar: Element) =>
    {
        const taxonomy: string = searchbar.getAttribute("data-searchbar");

        if (taxonomy)
        {
            new SearchBar({
                taxonomy: taxonomy,
            });
        }
    });
}


import { Accordion } from "./search/components/common";

const accordions: NodeListOf<HTMLElement> = document.querySelectorAll(".c-Accordion");

if (accordions)
{

    accordions.forEach((accordion: Element) =>
    {
        new Accordion({
            html: accordion,
        });
    });
}